import { render, staticRenderFns } from "./TaskMoneyConfigtaskTypeList.vue?vue&type=template&id=fd544d04&"
import script from "./TaskMoneyConfigtaskTypeList.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigtaskTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigtaskTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports